import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal/Modal';

/*
"Are you sure?" for the Radio deletes, on the shared Modal. Not DeleteModal: that one
has a single OK button, and clicking its backdrop runs the action, which is the wrong
default for a delete. Here the backdrop, Escape and the X all cancel.

`errors` shows what the backend answered (e.g. a program that still has episodes),
and the dialog stays open so the editor reads it.
*/
const RadioConfirmModal = ({
  title, children, confirmLabel, onConfirm, onCancel, busy, errors,
}) => (
  <Modal title={title} handleClick={onCancel} positionMiddle size="w-1/2" zIndex="50">
    <div className="radio-confirm">
      {children}
      {errors && errors.length ? (
        <div className="radio-errors-box" style={{ marginTop: 16 }}>
          {errors.map(error => <p key={error}>{error}</p>)}
        </div>
      ) : null}
      <div className="radio-buttons">
        <button type="button" className="radio-button is-ghost" onClick={onCancel} disabled={busy}>
          {errors && errors.length ? 'Close' : 'Cancel'}
        </button>
        <button type="button" className="radio-button is-danger" onClick={onConfirm} disabled={busy}>
          {busy ? 'Working…' : confirmLabel}
        </button>
      </div>
    </div>
  </Modal>
);

RadioConfirmModal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
};

RadioConfirmModal.defaultProps = {
  confirmLabel: 'Delete',
  busy: false,
  errors: [],
};

export default RadioConfirmModal;
